import { svg as t } from "lit";
import { IDSIconBase as r } from "../icon-base-element.js";
class o extends r {
  constructor() {
    super(), this.vbHeight = 15, this.vbWidth = 15;
  }
  renderIcon() {
    return t`<path fill="${this.colors.color}" xmlns="http://www.w3.org/2000/svg" d="M10.6962 8.6172L0.375038 8.6172C0.16791 8.6172 0 8.44929 0 8.24216V6.742C0 6.53488 0.167911 6.36697 0.375039 6.36697L10.6896 6.36697L6.17408 1.85095C6.02764 1.70449 6.02764 1.46705 6.17408 1.32059L7.23479 0.259763C7.38126 0.113282 7.61874 0.113282 7.76521 0.259763L15 7.49536L7.76521 14.731C7.61874 14.8774 7.38126 14.8774 7.23479 14.731L6.17408 13.6701C6.02764 13.5237 6.02764 13.2862 6.17408 13.1398L10.6962 8.6172Z"></path>`;
  }
}
export { o as IDSIconArrow };